"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function SupportIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M12,2.2A9.8,9.8,0,1,0,21.8,12,9.808,9.808,0,0,0,12,2.2Zm7.353,5.968-2.622,1.2a5.451,5.451,0,0,0-2.3-2.2l1.2-2.617A8.341,8.341,0,0,1,19.353,8.172ZM12,15.914A3.914,3.914,0,1,1,15.914,12,3.919,3.919,0,0,1,12,15.914ZM8.366,4.554l1.2,2.617a5.451,5.451,0,0,0-2.3,2.2l-2.622-1.2A8.341,8.341,0,0,1,8.366,4.554ZM4.519,15.562l2.617-1.2A5.447,5.447,0,0,0,9.444,16.77l-1.2,2.617A8.344,8.344,0,0,1,4.519,15.562Zm11.237,3.825-1.2-2.617a5.447,5.447,0,0,0,2.308-2.407l2.617,1.2A8.344,8.344,0,0,1,15.756,19.387Z" })));
}
exports.default = SupportIcon;
